import { DateTime } from 'luxon'
import { axiosInterceptors } from '~/utils/axiosInterceptor'

class LogApi {
	// eslint-disable-next-line max-params
	constructor(axios, baseUrl, service, store, route) {
		this.axios = axios
		this.baseUrl = baseUrl
		this.service = service
		this.store = store
		this.route = route
	}

	getDefaultMeta() {
		return {
			userId: this.store.state.user.userId,
			playerTag: this.store.state.playerTag,
			scToken: this.store.state.scToken,
			country: this.store.state.country,
			date: DateTime.local().toISO(),
			userAgent: window?.navigator?.userAgent || 'N/A',
		}
	}

	createLogMessage(message, meta = {}) {
		try {
			const defaultMeta = this.getDefaultMeta()
			return this.axios.post(`${this.baseUrl}/log`, {
				error: message,
				meta: { ...defaultMeta, ...meta },
				url: this.route.fullPath,
			})
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error(error)
		}
	}

	createDebugMessage(message, meta = {}) {
		if (this.service !== 'dev') {
			return
		}

		try {
			const defaultMeta = this.getDefaultMeta()
			return this.axios.post(`${this.baseUrl}/log`, {
				error: `[DEBUG] ${message}`,
				meta: { ...defaultMeta, ...meta },
				url: this.route.fullPath,
			})
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error(error)
		}
	}
}

export default ({ $axios, $config, store, route }, inject) => {
	const logApi = $axios.create()

	axiosInterceptors(logApi)
	inject('logApi', new LogApi(logApi, $config.logBaseUrl, $config.service, store, route))
}
